// config/envLoader.js
// Environment configuration loader for React applications
// This module provides access to environment variables loaded at build time

/**
 * React environment variables are loaded at build time through Create React App
 * The .env files need to be in the root directory for Create React App to process them
 * This module provides a centralized configuration object for accessing these variables
 */

// config/envLoader.js
// Environment configuration loader for React applications
// This module provides access to environment variables loaded at build time

/**
 * React environment variables are loaded at build time through Create React App
 * The .env files are processed by our build script to merge shared and environment-specific configs
 * This module provides a centralized configuration object for accessing these variables
 */

// Configuration object for easy access to environment variables
const config = {
    // Environment
    environment: process.env.REACT_APP_ENVIRONMENT,

    // API Configuration
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    apiTimeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,

    // Application Configuration
    port: parseInt(process.env.PORT) || 3050,
    title: process.env.REACT_APP_TITLE || 'Enterprise Portal',
    version: process.env.REACT_APP_VERSION,
    buildNumber: process.env.REACT_APP_BUILD_NUMBER,

    // Authentication
    sessionTimeout: parseInt(process.env.REACT_APP_SESSION_TIMEOUT) || 3600000,
    tokenStorageKey: process.env.REACT_APP_TOKEN_STORAGE_KEY || 'authToken',
    tokenExpiryWarningMinutes: parseInt(process.env.REACT_APP_TOKEN_EXPIRY_WARNING_MINUTES) || 2,
    tokenExpiryCheckIntervalMinutes: parseInt(process.env.REACT_APP_TOKEN_EXPIRY_CHECK_INTERVAL_MINUTES) || 1,

    // Feature Flags
    features: {
        audit: process.env.REACT_APP_ENABLE_AUDIT === 'true',
        billing: process.env.REACT_APP_ENABLE_BILLING === 'true',
        organizations: process.env.REACT_APP_ENABLE_ORGANIZATIONS === 'true',
    },

    // UI Configuration
    ui: {
        theme: process.env.REACT_APP_THEME || 'light',
        sidebarCollapsed: process.env.REACT_APP_SIDEBAR_COLLAPSED === 'true',
    },

    // Company/Brand
    company: {
        name: process.env.REACT_APP_COMPANY_NAME || 'Caelus Tech Limited',
        logoUrl: process.env.REACT_APP_COMPANY_LOGO_URL || '/logo512.png',
    },

    // Debug Configuration
    debug: {
        general: process.env.REACT_APP_DEBUG_GENERAL_INFORMATION === 'true',
        auth: process.env.REACT_APP_DEBUG_AUTH_INFORMATION === 'true',
        formSubmission: process.env.REACT_APP_DEBUG_FORM_SUBMISSION === 'true',
        apiCall: process.env.REACT_APP_DEBUG_API_CALL === 'true',
        apiPrefetch: process.env.REACT_APP_DEBUG_API_PREFETCH === 'true',
        apiResponse: process.env.REACT_APP_DEBUG_API_RESPONSE === 'true',
        componentLoad: process.env.REACT_APP_DEBUG_COMPONENT_LOAD === 'true',
        logging: process.env.REACT_APP_ENABLE_LOGGING === 'true',
    },

    // Environment-specific messages
    warnings: {
        environment: process.env.REACT_APP_ENVIRONMENT_WARNING,
        login: process.env.REACT_APP_LOGIN_WARNING,
    }
};

// Helper function to log current configuration (useful for debugging)
export const logConfiguration = () => {
    if (config.debug.general) {
        console.log('Current Environment Configuration:', config);
    }
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (featureName) => {
    return config.features[featureName] || false;
};

// Helper function to get environment-specific API URL
export const getApiUrl = (endpoint = '') => {
    const baseUrl = config.apiBaseUrl?.replace(/\/$/, ''); // Remove trailing slash
    const cleanEndpoint = endpoint.replace(/^\//, ''); // Remove leading slash
    return cleanEndpoint ? `${baseUrl}/${cleanEndpoint}` : baseUrl;
};

export { config };
export default config;